module.exports = __webpack_public_path__ + "img/reset-bg.faeee06e.png";